import {
	customerAttrGlobalApply,
	customerAttrGlobalAssign,
	customerAttrGlobalAssignConfirm,
	customerAttrGlobalAssignEdit,
	customerAttrGlobalAssignPaginate,
	customerAttrIndividualApply
} from 'api/CustomerAttrGlobalUploadApi'
import {} from 'models/CrudCustomerInterface'
import {
	ICrudApplyCustomerAttrFiltersSaga,
	ICrudApplyCustomerAttrIndividualSaga,
	ICrudCustomerAttrGlobalAssignConfirmSaga,
	ICrudCustomerAttrGlobalAssignEditSaga,
	ICrudCustomerAttrGlobalAssignPaginationSaga,
	ICrudCustomerAttrGlobalAssignSaga
} from 'models/CustomerGlobalUploadInterface'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import {
	customerAttrGlobalApplySuccess,
	customerAttrGlobalAssignConfirmSuccess,
	customerAttrGlobalAssignEditRes,
	customerAttrGlobalAssignPaginateSuccess,
	customerAttrGlobalAssignSuccess,
	customerAttrIndividualApplySuccess
} from '../actions'
import {
	EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_CUSTOMER_ATTR_GLOBAL_FILTERS,
	SET_CUSTOMER_ATTR_INDIVIDUAL
} from '../constants/ActionsTypes'

function* customerAttrGlobalApplyReq({
	payload
}: ICrudApplyCustomerAttrFiltersSaga): any {
	try {
		const values: any = yield call(customerAttrGlobalApply, payload)
		yield put(customerAttrGlobalApplySuccess(values))
	} catch (error) {}
}

function* customerAttrIndividualApplyReq({
	payload
}: ICrudApplyCustomerAttrIndividualSaga): any {
	try {
		const values: any = yield call(customerAttrIndividualApply, payload)
		yield put(customerAttrIndividualApplySuccess(values))
	} catch (error) {}
}
function* customerAttrGlobalAssignConfirmReq({
	payload
}: ICrudCustomerAttrGlobalAssignConfirmSaga): any {
	try {
		const values: any = yield call(customerAttrGlobalAssignConfirm, payload)
		yield put(customerAttrGlobalAssignConfirmSuccess(values))
	} catch (error) {}
}

function* customerAttrGlobalAssignEditReq({
	payload
}: ICrudCustomerAttrGlobalAssignEditSaga): any {
	try {
		const values: any = yield call(customerAttrGlobalAssignEdit, payload)
		yield put(customerAttrGlobalAssignEditRes(values))
	} catch (error) {}
}
function* customerAttrGlobalAssignReq({
	payload
}: ICrudCustomerAttrGlobalAssignSaga): any {
	try {
		const values: any = yield call(customerAttrGlobalAssign, payload)
		yield put(customerAttrGlobalAssignSuccess(values))
	} catch (error) {}
}
function* customerAttrGlobalAssignPaginationReq({
	payload
}: ICrudCustomerAttrGlobalAssignPaginationSaga): any {
	try {
		const values: any = yield call(customerAttrGlobalAssignPaginate, payload)
		yield put(customerAttrGlobalAssignPaginateSuccess(values))
	} catch (error) {}
}
export function* customerAttrGlobalApplySaga() {
	yield takeLatest(SET_CUSTOMER_ATTR_GLOBAL_FILTERS, customerAttrGlobalApplyReq)
}
export function* customerAttrIndividualApplySaga() {
	yield takeLatest(SET_CUSTOMER_ATTR_INDIVIDUAL, customerAttrIndividualApplyReq)
}
export function* customerAttrGlobalAssignConfirmSaga() {
	yield takeLatest(
		SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_CONFIRM,
		customerAttrGlobalAssignConfirmReq
	)
}

export function* customerAttrGlobalAssignEditSaga() {
	yield takeLatest(
		EDIT_CUSTOMER_ATTR_GLOBAL_ASSIGN,
		customerAttrGlobalAssignEditReq
	)
}
export function* customerAttrGlobalAssignSaga() {
	yield takeLatest(SET_CUSTOMER_ATTR_GLOBAL_ASSIGN, customerAttrGlobalAssignReq)
}
export function* customerAttrGlobalAssignPaginationSaga() {
	yield takeLatest(
		SET_CUSTOMER_ATTR_GLOBAL_ASSIGN_PAGINATION,
		customerAttrGlobalAssignPaginationReq
	)
}

export default function* rootSaga() {
	yield all([
		fork(customerAttrGlobalApplySaga),
		fork(customerAttrIndividualApplySaga),
		fork(customerAttrGlobalAssignConfirmSaga),
		fork(customerAttrGlobalAssignEditSaga),
		fork(customerAttrGlobalAssignSaga),
		fork(customerAttrGlobalAssignPaginationSaga)
	])
}
